import { render, staticRenderFns } from "./AutoMoto.vue?vue&type=template&id=5cf40550&"
import script from "./AutoMoto.vue?vue&type=script&lang=js&"
export * from "./AutoMoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports